// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"8":"mobile","380":"desktop"}[chunkId] || chunkId) + "." + {"8":"ecfffc59","380":"9d7c6d9f","495":"734fc3e4"}[chunkId] + ".chunk.css";
};